import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'FLASH_DEAL_FORM'
export const FlashdealFormAction = createFormAction(FORM_KEY)